import React, { useState } from "react";
import { useSelector } from "react-redux";
import {
  Modal,
  Box,
  Button,
  Typography,
  Stack,
  IconButton,
  TextField,
  CircularProgress,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

// functions
import { createBulkRooms } from "../../../../functions/restaurant";

// cUSTOM cOMPONENTS
import CustomSnackBar from "../../../common/utils/CustomSnackBar";
import { notify } from "../../../Toast";

const AreaSettingModal = ({ openAreaSettingModal, closeAreaSettingModal, refetch }) => {
  const [values, setValues] = useState({
    place_type: "Area",
    from_no: 1,
    prefix: "",
    units: 10,
    person_per_table: 5,
    openSnackBar: false,
    snackBarMessage: "",
    snackBarSeverity: "success",
  });
  const [loading, setLoading] = useState(false);

  const {
    place_type,
    from_no,
    prefix,
    units,
    person_per_table,
    openSnackBar,
    snackBarMessage,
    snackBarSeverity,
  } = values;

  const { currentBranch } = useSelector((state) => state.branch);
  const branchId = currentBranch?.id

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };
  const closeSnackBar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setValues({ ...values, openSnackBar: false });
  };

  const handleClose = () => {
    closeAreaSettingModal();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true)

    if (!branchId) {
      setLoading(false)
      notify('Please Select Branch', 'error')
    } else {
      setLoading(false)
    
      createBulkRooms(
        place_type,
        Number(from_no),
        prefix,
        Number(units),
        Number(person_per_table),
        branchId
      )
        .then((res) => {
          setLoading(false)
          console.log(
            "🚀 ~ file: AreaSettingModal.js:45 ~ createBulkRooms ~ res",
            res
          );
          notify(res.data.message, 'success')
          refetch()
          handleClose()
        })
        .catch((err) => {
          setLoading(false)
          console.log("🚀 ~ file: AreaSettingModal.js:93 ~ ).then ~ err", err);
          notify(err.message, 'error')
        });
    }
  };

  return (
    <Modal open={openAreaSettingModal} onClose={handleClose}>
      <Stack
        sx={(theme) => ({
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "40vw",
          bgcolor: "background.paper",

          borderRadius: 2,
          borderColor: `primary.main`,
          elevation: 24,
          [theme.breakpoints.down("md")]: {
            width: "80vw",
          },
        })}
      >
        <Box sx={{ position: "absolute", top: 5, right: 5 }}>
          <IconButton onClick={handleClose}>
            <CloseOutlinedIcon
              sx={{ borderRadius: 25, bgcolor: "black", color: "white" }}
            />
          </IconButton>
        </Box>
        <Stack sx={{ p: 4, my: 2 }}>
          {" "}
          <Typography variant="h4" fontWeight="500" color="black">
            Area Setting
          </Typography>
          <Typography sx={{}} variant="h6">
            Configure Areas for this Branch
          </Typography>
          <form onSubmit={(e) => handleSubmit(e)}>
            <Grid container spacing={2} sx={{ mt: 2 }}>
              {" "}
              <Grid xs={12} md={6}>
                <Typography color="black">Starting Number</Typography>
                <TextField
                  type={"number"}
                  fullWidth
                  required
                  value={values.from_no}
                  onChange={handleChange("from_no")}
                />
              </Grid>{" "}
              <Grid xs={12} md={6}>
                <Typography color="black">Area Prefix</Typography>
                <TextField
                  placeholder="E.g: G, FF, SF"
                  fullWidth
                  value={values.prefix}
                  onChange={handleChange("prefix")}
                />
              </Grid>
              <Grid xs={12} md={6}>
                <Typography color="black">Number of Areas</Typography>
                <TextField
                type={"number"}
                  fullWidth
                  value={values.units}
                  onChange={handleChange("units")}
                />
              </Grid>{" "}
              <Grid xs={12} md={6}>
                <Typography color="black">People Per Table</Typography>
                <TextField
                  fullWidth
                  type={"number"}
                  value={values.person_per_table}
                  onChange={handleChange("person_per_table")}
                ></TextField>
              </Grid>
            </Grid>
            <Button
              type="submit"
              disabled={loading}
              onClick={(e) => handleSubmit(e)}
              disableElevation
              sx={{ mt: 4, height: 55, fontSize: "1rem", color: "white" }}
              variant="contained"
              fullWidth
            >
              {loading ? (<CircularProgress color="inherit" size="1.5rem" />) : "Save Changes"}
            </Button>
          </form>
        </Stack>
      </Stack>
    </Modal>
  );
};

export default AreaSettingModal;
